import { IConfigurationField, ConfigurationField } from '@/models/configuration/Field';
import { TableMenuActionColorEnums } from '@/enums/TableMenuActionEnums';
import { IConfigurationSection } from '@/models/configuration/Section';

export interface ITableDataSetField extends IConfigurationField {
    changed: boolean;
    fields?: TableDataSetField[];
    color: TableMenuActionColorEnums;
}

export class TableDataSetField extends ConfigurationField {
    public changed: boolean;
    public fields?: TableDataSetField[];
    public color: TableMenuActionColorEnums;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: ITableDataSetField);
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IConfigurationField);
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IConfigurationSection);
    constructor(obj?: any) {
        super(obj);
        this.changed = obj && obj.valueBool != null ? obj.valueBool : false;
        this.color = obj && obj.color != null ? obj.color : TableMenuActionColorEnums.UNMARK;
        this.fields = undefined;
        if (obj && obj.fields !== undefined) {
            this.fields = [];
            obj.fields.forEach((field: ConfigurationField | TableDataSetField) => {
                this.fields!.push(new TableDataSetField(field));
            });
        }
    }
}
